import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {GRID_ITEM_TYPE} from '@Components/base-grid/components/grid-item';
import type {GridUserImageItemStorage} from '@Components/base-grid/components/grid-user-image-item';
import type {GridUserAudioItemStorage} from '@Components/base-grid/components/grid-user-audio-item';
import {escapeHTML} from '@Utils/string.util';

export const isGridUserImageItem = (gridItem: GridItemStorage): gridItem is GridUserImageItemStorage => {
  return gridItem.type === GRID_ITEM_TYPE.USER_IMAGE;
};

export const isGridUserAudioItem = (gridItem: GridItemStorage): gridItem is GridUserAudioItemStorage => {
  return gridItem.type === GRID_ITEM_TYPE.USER_AUDIO;
};

/** The hover title on a user media tile in a shared folder, naming who added it; empty when no uploader is known. */
export const getAddedByTitle = (uploaderName: string): string => {
  return uploaderName ? `${window.i18next.t('pmwjs_added_by')} ${escapeHTML(uploaderName)}` : '';
};
